// $('.footer_newsletter').on('submit', function(e) {
//     e.preventDefault();

//     $.ajax({
//         url     : "https://cdn.byparra.com/add_mailchimp.php",
//         method  : 'POST',
//         data    : {
//             'email' : $('.footer_newsletter input[name="contact[email]"]').val(),
//             'FNAME' : $('.footer_newsletter input[name="contact[first_name]"]').val()
//         },
//         success : function(res) {
//             if (res === 1 || res === '1') {
//                 $('.footer_newsletter input').val('');
//                 $('.footer_newsletter button[type=submit]').addClass('send').html('Subscribed');
//             } else {
//                 console.log('error');
//             }
//         },
//         error : function(res) {
//             console.log('error');
//         }
//     })
// })

if (window.location.hash) {
    var hash = window.location.hash;
    
    if ($(hash).length) {
        $('html, body').animate({
            scrollTop: $(hash).offset().top
        }, 0, 'swing');
    }
}